module.exports = __webpack_public_path__ + "media/images/Amsale-BM-b5b71628.webp";